import React, { InputHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'size'> {
  label?: string;
  error?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
  size?: 'sm' | 'md';
}

const Input: React.FC<InputProps> = ({
  className,
  type = 'text',
  label,
  placeholder,
  value,
  onChange,
  error,
  required,
  disabled,
  size = 'md',
  ...props
}) => {
  const sizeClasses =
    size === 'sm' ? 'px-2 py-1 rounded-md text-xs' : 'px-3 py-2 rounded-lg';
  const labelClasses = size === 'sm' ? 'text-xs' : 'text-sm';
  const wrapperSpacing = size === 'sm' ? 'space-y-1' : 'space-y-2';
  return (
    <div className={wrapperSpacing}>
      {label && (
        <label
          className={cn('block font-medium text-foreground', labelClasses)}
        >
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        className={cn(
          'block w-full border border-border shadow-sm text-foreground placeholder-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition-colors',
          sizeClasses,
          error &&
            'border-destructive focus:ring-destructive focus:border-destructive',
          disabled && 'bg-muted cursor-not-allowed',
          className
        )}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default Input;
